export enum ProductPartnership {
  Default = "",
  Gadget = "gadget",
  Finance = "finance",
  MicroHealth = "microhealth",
  Travel = "travel",
  Logistic = "logistic",
  Vehicle = "vehicle",
  Goods = "goods",
}
